export default __webpack_public_path__ + "static/media/criar-consorcio.6da786ac.png";